import Request from '@/libraries/request.js';
import Const from '@/const/const.js';

export default {
  BaseURL: '/user',
  async get(url = null) {
    const users = await Request.getAsync(url);
    let data = {};
    if (users.data.status) {
      data = users.data.data;
    }
    // console.log(data);
    return data;
  },
  async get_users(usrId = null) {
    let url;
    if (usrId == null) {
      url = this.BaseURL;
    } else {
      url = this.BaseURL + '/' + usrId;
    }

    const data = await this.get(url);
    return data;
  },

  async get_groups(id = null) {
    let url;
    if (id) {
      url = '/group/' + id;
    } else {
      url = '/group';
    }
    const data = await this.get(url);
    return data;
  },
};



// WEBPACK FOOTER //
// ./src/model/user_model.js